/**
 * Guide Run status
 */
export enum GuideRunStatus {
  /**
   * This is the status after activation and during normal use of a guide before was ended. Scheduled Tasks that belong
   * to a guide are only available while the guide is enabled, otherwise they are deleted.
   */
  enabled = 'enabled',
  /**
   * This is status if the guide has been completed. It it triggered by the anchor of {@link GuideHeader.termination}
   */
  ended = 'ended',
  /**
   * This is set if a guide is disabled by the user (currently not possible) or because a new main guide has been
   * activated. This status should be treated equivalently to `'ended'`.
   */
  disabled = 'disabled',
  /**
   * @deprecated
   * If no items belonging to this `guideRun` have been logged within the last {@link GuideHeader.maxDurationInactive}
   * days, the guide was marked as inactive. This might still be present in the DB and should be treated as `'ended'`
   * or `'disabled'`.
   */
  inactive = 'inactive',
}
